var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Policy Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0808545 8.89191C0.197363 7.27995 1.46455 6.02845 3.07746 5.92593C4.04202 5.86462 5.22142 5.81641 6.54545 5.81641C7.86948 5.81641 9.04889 5.86462 10.0135 5.92593C11.6264 6.02845 12.8935 7.27995 13.0101 8.89191C13.0571 9.54251 13.0909 10.2418 13.0909 10.9073C13.0909 11.5728 13.0571 12.2721 13.0101 12.9227C12.8935 14.5347 11.6264 15.7862 10.0135 15.8887C9.04889 15.95 7.86949 15.9982 6.54545 15.9982C5.22142 15.9982 4.04202 15.95 3.07746 15.8887C1.46455 15.7862 0.197363 14.5347 0.0808546 12.9227C0.0338308 12.2721 0 11.5728 0 10.9073C0 10.2418 0.0338308 9.54251 0.0808545 8.89191ZM8 10.18C8 10.7184 7.70749 11.1885 7.27273 11.44V12.3619C7.27273 12.7635 6.94712 13.0891 6.54545 13.0891C6.14379 13.0891 5.81818 12.7635 5.81818 12.3619V11.44C5.38342 11.1885 5.09091 10.7184 5.09091 10.18C5.09091 9.37672 5.74213 8.7255 6.54545 8.7255C7.34878 8.7255 8 9.37672 8 10.18Z",
    fill: "#152946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91016 3.63636C2.91016 1.62806 4.53821 0 6.54652 0C8.55483 0 10.1829 1.62806 10.1829 3.63636V6.54545C10.1829 6.94712 9.85727 7.27273 9.45561 7.27273C9.05395 7.27273 8.72834 6.94712 8.72834 6.54545V3.63636C8.72834 2.43138 7.7515 1.45455 6.54652 1.45455C5.34153 1.45455 4.3647 2.43138 4.3647 3.63636V6.54545C4.3647 6.94712 4.03909 7.27273 3.63743 7.27273C3.23577 7.27273 2.91016 6.94712 2.91016 6.54545V3.63636Z",
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSidebar);
export default __webpack_public_path__ + "static/media/lock-sidebar.b831c3861e986adfb038291c1f0cf486.svg";
export { ForwardRef as ReactComponent };